import { goodVibeCardEn, goodVibeDetailDialogEn } from "@domains/good-vibes/client/i18n/en.ts";
export const en = {
    CreateMenu: {
        newGoodVibe: "New Good Vibe",
        newFeedback: "New feedback"
    },
    Navigation: {
        home: {
            label: "Home",
            description: "Your daily brief"
        },
        "manager-impact": {
            label: "My impact as a manager"
        }
    },
    HomePage: {
        title: "Home",
        error: "We couldn't load your home dashboard right now.",
        liveRegion: {
            loading: "Loading…"
        }
    },
    Errors: {
        retry: "Try again",
        retrying: "Retrying…",
        reassurance: "Please try again later.",
        refreshBanner: "Couldn't refresh — showing the last results."
    },
    HomeBriefCard: {
        title: "Weekly brief",
        weekOf: "Week of {{date}}",
        older: "Show the previous brief",
        newer: "Show the next brief",
        doneThatWeek_one: "{{done}} of {{count}} done that week",
        doneThatWeek_other: "{{done}} of {{count}} done that week",
        pastWeek: "Past week",
        noBrief: "No weekly brief yet",
        worthKnowing: "Worth knowing",
        runtime: {
            feedbackUnread_zero: "Read your new feedback messages",
            feedbackUnread_one: "Read {{count}} new feedback message",
            feedbackUnread_other: "Read {{count}} new feedback messages",
            goodVibes_zero: "Open your new Good Vibes",
            goodVibes_one: "Open {{count}} new Good Vibe",
            goodVibes_other: "Open {{count}} new Good Vibes",
            goalUpdates_zero: "Review your goal updates this week",
            goalUpdates_one: "Review {{count}} goal update this week",
            goalUpdates_other: "Review {{count}} goal updates this week",
            selfReview: "Write your self review",
            reviews_zero: "Write your reviews",
            reviews_one: "Write {{count}} review",
            reviews_other: "Write {{count}} reviews",
            moreReviews_one: "{{count}} more review to write",
            moreReviews_other: "{{count}} more reviews to write"
        },
        draft: {
            sent: "Sent",
            completeError: "Sent, but we couldn't mark it done on your list."
        },
        cta: {
            prompt: {
                addToAgenda: "Add this to the agenda of the 1:1 it belongs to: {{title}}",
                prepTalkingPoints: "Prep my talking points for this item from my weekly brief: {{title}}",
                bookMeeting: "Book a meeting for this item from my weekly brief: {{title}}",
                followUp: "Follow up on these action items: {{title}}",
                draftGoodVibe: "Draft a Good Vibe for this item from my weekly brief: {{title}}",
                replyFeedback: "Draft a reply to this feedback from my weekly brief: {{title}}",
                draftReply: "Draft my Slack reply for this item from my weekly brief: {{title}}"
            }
        },
        personalize: "Personalize your brief",
        loading: "Loading your weekly brief",
        error: "We couldn't load your weekly brief.",
        retry: "Try again",
        generating: "Preparing this week's brief. This can take a few minutes.",
        generationError: "We couldn't prepare your weekly brief.",
        writeError: "We couldn't save that change. Try again.",
        clearError: "We couldn't clear the done items. Try again.",
        refresh: {
            label: "Refresh your brief",
            title: "Refresh",
            running: "Refreshing your brief",
            done: "Your brief is up to date",
            error: "We couldn't refresh your brief. Your current brief is unchanged.",
            lastUpdated: "Last updated: {{time}}"
        }
    },
    HomeBriefList: {
        due: {
            late_one: "{{count}}d late",
            late_other: "{{count}}d late",
            today: "Today",
            thisWeek: "This week"
        },
        dueSpoken: {
            late_one: "{{count}} day late",
            late_other: "{{count}} days late",
            today: "Due today",
            thisWeek: "Due this week",
            on: "Due {{date}}"
        },
        markDone: 'Mark "{{title}}" as done',
        doneWhenRead: '"{{title}}" is done when you have read them all',
        needsAttention: "Needs your attention",
        looksDone: "Looks done",
        clear: {
            title: "You're clear for the week",
            allDone_one: "Your one item is done",
            allDone_other: "All {{count}} done this week",
            subtitle: "Anything new that needs you shows up here."
        },
        state: {
            done: "Done",
            open: "Not done"
        },
        showMore: "Show more",
        showLess: "Show less",
        clearDone: "Clear done",
        seeAllActionItems: "See all action items"
    },
    BriefActions: {
        bookMeeting: "Book a meeting",
        sendGoodVibe: "Send a Good Vibe",
        reply: "Reply",
        sendMessage: "Send message",
        addToAgenda: "Add to agenda",
        prepTalkingPoints: "Prep talking points",
        followUp: "Follow up",
        reviewGoodVibe: "Review Good Vibe",
        reviewReply: "Review reply",
        reviewMessage: "Review message",
        read: "Read",
        connect: "Connect {{app}}",
        connectCalendar: "Connect calendar",
        connectWhy: {
            gitHub: "Connect GitHub to see the pull request, its checks and its reviews.",
            jira: "Connect Jira to see the ticket and where it stands.",
            confluence: "Connect Confluence to see the page and what changed on it.",
            slack: "Connect Slack to see the whole thread.",
            google: "Connect Google to see the document and its latest edits.",
            sharePoint: "Connect SharePoint to see the document and its latest edits."
        },
        opensInNewTab: "opens in a new tab"
    },
    BriefGoodVibesDialog: {
        title: "New Good Vibes",
        loading: "Loading Good Vibes",
        error: "We couldn't load your Good Vibes.",
        viewer: {
            title: "Yours",
            seeAll: "See all your Good Vibes"
        },
        team: {
            title: "Your team",
            seeAll: "See your team's Good Vibes"
        },
        more: "See all Good Vibes",
        empty: "Nothing new",
        sealed: {
            badge: "New Good Vibes",
            pressAndHold: "Press and hold to open",
            ariaLabel: "A new Good Vibe for {{recipients}} — press and hold to open"
        },
        addCommentError: "An error occurred while posting your reply. Please try again.",
        editCommentSuccess: "Reply updated",
        editCommentError: "An error occurred while updating your reply. Please try again.",
        deleteCommentSuccess: "Reply deleted",
        deleteCommentError: "An error occurred while deleting your reply. Please try again."
    },
    GoodVibesCard: { ...goodVibeCardEn },
    GoodVibesDetailDialog: { ...goodVibeDetailDialogEn },
    HomeAgentPanel: {
        greeting: {
            morning: "👋 Good morning, {{name}}.",
            afternoon: "👋 Good afternoon, {{name}}.",
            evening: "👋 Good evening, {{name}}."
        },
        briefGreeting: {
            morning: "☕\u00a0 Good morning, {{name}}",
            afternoon: "☀️\u00a0 Good afternoon, {{name}}",
            evening: "🌙\u00a0 Good evening, {{name}}",
            night: "🌙\u00a0 Good night, {{name}}"
        },
        inputLabel: "Ask your agent",
        inputPlaceholder: "Ask anything about your team or your company",
        sendLabel: "Send to your agent",
        quickPrompts: {
            teamDoing: "How is my team doing?",
            worthAttention: "What's worth my attention?",
            whoToRecognize: "Who should I recognize this week?"
        }
    },
    HomePerformanceCard: {
        badge: "Active review cycle",
        empty: "No active review cycle",
        opensInNewTab: "Opens in a new tab",
        rows: {
            selfReview: "Self reviews",
            managerReview: "Manager reviews",
            peerReview: "Peer reviews",
            upwardReview: "Upward reviews"
        }
    },
    HomePerformanceCarousel: {
        counter: "{{current}} of {{total}}",
        previous: "Previous cycle",
        next: "Next cycle"
    },
    HomeNewAndOutstanding: {
        heading: "New and outstanding",
        empty: "You're all caught up — nothing new for your team.",
        reviewsToWriteNoun_one: "review to write",
        reviewsToWriteNoun_other: "reviews to write",
        reviewsToWriteShowMore_one: "Show 1 more",
        reviewsToWriteShowMore_other: "Show {{count}} more",
        reviewsToWriteShowLess: "Show less",
        reviewerAssignmentsNoun_one: "reviewer assignment to make",
        reviewerAssignmentsNoun_other: "reviewer assignments to make",
        assignment: {
            peer: "Assign peers to review {{name}}",
            upward: "Assign upward reviewers for {{name}}",
            peerDue: "Peer review due {{date}}",
            upwardDue: "Upward review due {{date}}"
        },
        review: {
            self: "Your self review",
            managerOf: "Manager review of {{name}}",
            peerOf: "Peer review of {{name}}",
            upwardOf: "Upward review of {{name}}",
            due: "Due {{date}}"
        },
        badges: {
            unreadFeedback: "unread feedback messages",
            newGoodVibes_one: "new Good Vibe for me",
            newGoodVibes_other: "new Good Vibes for me",
            unseenReportsGoodVibes_one: "unseen Good Vibe for my reports",
            unseenReportsGoodVibes_other: "unseen Good Vibes for my reports",
            goalUpdates: "recent goal updates"
        }
    },
    HomeMyTeam: {
        heading: "My team",
        empty: "No team members",
        actions: {
            label: "Actions for {{name}}",
            sendGoodVibes: "Send Good Vibes",
            openNextOneOnOne: "Open next 1:1"
        },
        scope: {
            ariaLabel: "Reports scope",
            allReports: "All reports",
            directReports: "Direct reports"
        },
        emptyDirect: "No direct reports"
    },
    HomeBringYourTeamIn: {
        heading: "Bring your team in",
        description: "Sync from your HRIS, Slack, Microsoft, or Google to keep your team up to date. You choose who gets synced.",
        connectHris: "Connect your HRIS",
        addManually: "Or add people manually",
        uploadSpreadsheet: "Upload a spreadsheet",
        invitePeople: "Invite people",
        modalBody: "Setting up your team happens in Workleap Classic for now. We'll take you there. Nothing will be lost."
    },
    ManagerImpactReportPage: {
        title: "My impact as a manager",
        subtitle: "How you're impacting your direct reports.",
        betaBadge: "Beta",
        breadcrumb: {
            ariaLabel: "Breadcrumb",
            home: "Home"
        },
        howToImprove: "How to improve",
        empty: "Your report isn't ready yet. Check back soon.",
        pillars: {
            heading: "Two pillars",
            subtitle: "Your overall score blends Practice (60%) and Outcome (40%)."
        },
        improveScorePrompt: "How can I improve my `{{scoreName}}` score? Give me specific actions I can take this week.",
        howToImprovePrompt: "How can I improve my impact as a manager? Tell me what to focus on.",
        liveRegion: {
            loading: "Loading…"
        },
        feedback: {
            heading: "How is this report?",
            description: "This report is new and still in beta. A quick read from you shapes what ships.",
            accurate: "This report is useful",
            inaccurate: "This report is not useful",
            placeholder: "Anything you would change? Optional.",
            submit: "Send feedback",
            thanks: "Thanks, we logged your feedback."
        }
    },
    ManagerImpactOverallScoreCard: {
        heading: "My latest management score",
        outOf: "/ {{max}}",
        status: {
            great: "Great",
            needsWork: "Needs work",
            noData: "Not enough data yet"
        }
    },
    ManagerImpactPillarCard: {
        practice: {
            title: "Practice",
            description: "What you control. Work on these now — they lift your score right away."
        },
        outcome: {
            title: "Outcome",
            description: "What follows. These rise only as your practice holds over time."
        },
        outOf: "/ {{max}}",
        composedOf: "Composed of",
        list: {
            ariaLabel: "Signals composing your {{pillar}} score"
        },
        status: {
            noData: "Not enough data yet"
        }
    },
    ManagerImpactComposingScoreRow: {
        status: {
            great: "Great",
            needsWork: "Needs work",
            noData: "Not enough data yet"
        },
        improveThisScore: "Get suggestions",
        signals: {
            "reply-rate-from-feedback": "Reply rate to feedback",
            "response-time-from-feedback": "Response time to feedback",
            "review-submission-rate": "Review submission rate",
            "goals-updated-hygiene": "Goal-update frequency",
            "recognition-sent": "Recognition given",
            "my-review-score": "My review score",
            "overall-review-score": "Overall review score",
            "enps-from-pulse": "Pulse eNPS",
            "goal-attainment": "Goal achievement",
            "relationship-with-manager": "Relationship with manager"
        },
        descriptions: {
            "reply-rate-from-feedback": "How much of your direct reports' feedback and messages you replied to in the past month.",
            "response-time-from-feedback": "How long, on average, you took to reply to your direct reports' feedback in the past month.",
            "review-submission-rate": "The share of your direct reports whose latest due review you submitted on time.",
            "goals-updated-hygiene": "The share of your team goals and your direct reports' goals that are kept up to date.",
            "recognition-sent": "How many of your direct reports you recognized in the last month.",
            "my-review-score": "Your own review score — the rating your leader (the person you report to) gave you. We rate this great when it reaches 70% of the review scale (for a 5-point scale, 3.5 out of 5).",
            "overall-review-score": "The average score across your direct reports' latest completed performance reviews. We rate this great when the average reaches 70% of the review scale (for a 5-point scale, 3.5 out of 5).",
            "enps-from-pulse": "How likely your direct reports are to recommend the company as a place to work.",
            "goal-attainment": "The share of goals reached, across goals owned by you or your direct reports.",
            "relationship-with-manager": "Your direct reports' relationship with manager score from the Pulse survey."
        }
    },
    ManagerImpactSignalInfo: {
        label: "About {{signal}}"
    },
    ManagerImpactLowConfidenceFlag: {
        label: "Low confidence — limited survey participation"
    },
    HomeManagerImpactTile: {
        title: "My impact as a manager",
        new: "New",
        seeReport: "See report",
        liveRegion: {
            loading: "Loading your impact report"
        },
        insight: {
            improve: "You can grow as a manager by focusing on {{opportunityLabel}}.",
            praise: "You're doing great as a manager. For an extra edge, look at {{opportunityLabel}}.",
            empty: "We're still gathering data on your direct reports."
        },
        opportunityLabels: {
            "reply-rate-from-feedback": "your reply rate to feedback",
            "response-time-from-feedback": "how quickly you reply to feedback",
            "review-submission-rate": "your review submission rate",
            "goals-updated-hygiene": "how often you keep goals updated",
            "recognition-sent": "how often you recognize your direct reports",
            "my-review-score": "your own review score",
            "overall-review-score": "your direct reports' review scores",
            "enps-from-pulse": "your direct reports' eNPS",
            "goal-attainment": "your direct reports' goal achievement",
            "relationship-with-manager": "your direct reports' relationship with you"
        }
    },
    HomeManagerImpactCard: {
        liveRegion: {
            loading: "Loading your impact report"
        },
        eyebrow: "New report",
        cta: "My impact report",
        insight: {
            improve: "You can grow as a manager by focusing on {{opportunityLabel}}. Check your report to see how.",
            praise: "You're doing great as a manager. For an extra edge, look at {{opportunityLabel}}.",
            empty: "We're still gathering data on your direct reports. Check your report to see what's tracked."
        },
        opportunityLabels: {
            "reply-rate-from-feedback": "your reply rate to feedback",
            "response-time-from-feedback": "how quickly you reply to feedback",
            "review-submission-rate": "your review submission rate",
            "goals-updated-hygiene": "how often you keep goals updated",
            "recognition-sent": "how often you recognize your direct reports",
            "my-review-score": "your own review score",
            "overall-review-score": "your direct reports' review scores",
            "enps-from-pulse": "your direct reports' eNPS",
            "goal-attainment": "your direct reports' goal achievement",
            "relationship-with-manager": "your direct reports' relationship with you"
        }
    }
};
